import React from 'react'

// TODO: Consider integrating AbortController signal in the fetches for increased robustness to cancel requests if the component is unmounted.
const requestAccessToken = async (idToken, url) => {
  const accessTokenResponse = await fetch(url, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',      
      'auth-id-token': idToken
    }
  });

  if (!accessTokenResponse.ok) {
    console.error('AuthFetcher::requestAccessToken Error: '+ accessTokenResponse.statusText);
    throw new Error('requestAccessToken failed: '+accessTokenResponse.statusText);
  }

  const accessToken = accessTokenResponse.headers.get('Authorization');
  if (!accessToken) {
    console.error('Error in AuthFetcher - Empty AccessToken!');
    throw new Error('Unauthorized. (empty access token');
  }

  return accessToken;  
}

const authFetch = async (method, idToken, accessToken, url) => {
  const response = await fetch(url, {
    'method': method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken,
      'auth-id-token': idToken
    }
  });

  if (!response.ok) {
    const msg = `Error in Authorized ${method} path: ${url}, Msg: ${response.statusText}`;
    console.error(msg);
    throw new Error(msg);
  }

  const text = await response.text();
  let data;
  if (text === '' || text.length === 0) {
    data = '';
  }
  else {
    try {    
      data = JSON.parse(text);
    }
    catch(error) {
      console.error('Unable to parse the response to Json. returning plain text.  Please verify...');
      data = text;
    }
  }
  
  return data;
}



const authorizedPost = async (idToken, accessToken, url, body = {}) => {
  const response = await fetch(url, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken,
      'auth-id-token': idToken
    },
    body: body
  });

  if (!response.ok) {
    const msg = `Error in Authorized Post path: ${url}, Msg: ${response.statusText}`;
    console.error(msg);
    throw new Error(msg);
  }

  const text = await response.text();
  let data;
  if (text === '' || text.length === 0) {
    data = '';
  }
  else {
    try {    
      data = JSON.parse(text);
    }
    catch(error) {
      console.error('Unable to parse the response to Json. returning plain text.  Please verify...');
      data = text;
    }
  }
  
  return data;
}

export const authPost = async (idToken, url, body) => {
  return await requestAccessToken(idToken, url).then(accessToken => authorizedPost(idToken, accessToken, url, body));
}


export const auzdPost = async (idToken, url) => {
  return await requestAccessToken(idToken, url)
          .then(accessToken => authorizedPost(idToken, accessToken, url))
}

export const authGet = async (idToken, url) => {
  return await requestAccessToken(idToken, url)
              .then(accessToken => authFetch('get', idToken, accessToken, url));
}

export default function AuthFetcher() {

  return (
    <div>AuthFetcher</div>
  )
}
